module.exports = __webpack_public_path__ + "img/chaticon.14b7af73.png";